import React from 'react';
import { Box, Grid, TextField, Button, Typography } from '@mui/material';

import UserSelectbox from '../common/form/autocomplete/UserSelectbox';
import FormMultiCheckbox from '../common/form/checkbox/FormMultiCheckbox';

const DeptAddForm = ({ formik, checkedRoles, onChangeChecked }) => {
  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 2,
          px: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              required
              fullWidth
              label="부서명"
              name="dptNm"
              id="dptNm"
              value={formik.values.dptNm}
              onChange={formik.handleChange}
              error={formik.touched.dptNm && Boolean(formik.errors.dptNm)}
              helperText={formik.touched.dptNm && formik.errors.dptNm}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              label="부서 이메일"
              name="emlAddr"
              id="emlAddr"
              value={formik.values.emlAddr}
              onChange={formik.handleChange}
              error={formik.touched.emlAddr && Boolean(formik.errors.emlAddr)}
              helperText={formik.touched.emlAddr && formik.errors.emlAddr}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <UserSelectbox
              formik={formik}
              name="leaderUuid"
              label="부서 관리자"
              margin="normal"
              variant="outlined"
            />
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{ my: 1 }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              역할
            </Typography>
          </Grid>
          <Grid item xs={11}>
            {/* <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                            <FormControlLabel
                                id="role_sales"
                                name="role_sales"
                                label="영업"
                                control={
                                    <Checkbox
                                        checked={formik.values.role_sales}
                                        onChange={formik.handleChange}
                                    />
                                }
                            />
                            <FormControlLabel
                                id="role_tech"
                                name="role_tech"
                                label="기술"
                                control={
                                    <Checkbox
                                        checked={formik.values.role_tech}
                                        onChange={formik.handleChange}
                                    />
                                }
                            />
                        </FormGroup> */}
            <FormMultiCheckbox
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'DPT',
                slcCd: 'PROPERTY',
              }}
              displayEmpty
              name="roleList"
              required={false}
              checkedList={checkedRoles}
              onChangeChecked={onChangeChecked}
            />
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              label="기타1"
              name="ectVal1"
              id="ectVal1"
              value={formik.values.ectVal1}
              onChange={formik.handleChange}
              error={formik.touched.ectVal1 && Boolean(formik.errors.ectVal1)}
              helperText={formik.touched.ectVal1 && formik.errors.ectVal1}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              label="기타2"
              name="ectVal2"
              id="ectVal2"
              value={formik.values.ectVal2}
              onChange={formik.handleChange}
              error={formik.touched.ectVal2 && Boolean(formik.errors.ectVal2)}
              helperText={formik.touched.ectVal2 && formik.errors.ectVal2}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              label="기타3"
              name="ectVal3"
              id="ectVal3"
              value={formik.values.ectVal3}
              onChange={formik.handleChange}
              error={formik.touched.ectVal3 && Boolean(formik.errors.ectVal3)}
              helperText={formik.touched.ectVal3 && formik.errors.ectVal3}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              label="통계병합부서"
              name="statMerge"
              id="statMerge"
              value={formik.values.statMerge}
              onChange={formik.handleChange}
              error={
                formik.touched.statMerge && Boolean(formik.errors.statMerge)
              }
              helperText={formik.touched.statMerge && formik.errors.statMerge}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              label="참조사항"
              name="dptDesc"
              id="dptDesc"
              value={formik.values.dptDesc}
              onChange={formik.handleChange}
              error={formik.touched.dptDesc && Boolean(formik.errors.dptDesc)}
              helperText={formik.touched.dptDesc && formik.errors.dptDesc}
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2,
          }}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default DeptAddForm;
